<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">{{ editing ? "Editar concepto" : "Nuevo concepto" }}</h1>
    </div>

    <form @submit.prevent="save" novalidate>
      <wz-card :title="editing ? 'Datos del concepto' : 'Datos del nuevo concepto'">
        <div class="flex flex-wrap -mx-2">
          <div v-if="editing" class="w-full md:w-1/4 mb-3 px-2">
            <wz-input label="Código" :disabled="true" v-model="form.code" />
          </div>
          <div class="w-full md:w-3/4 mb-3 px-2">
            <wz-input label="Nombre" required v-model="form.name" placeholder="Nombre del concepto"
              :error="$v.form.name.$error && !$v.form.name.required ? 'El nombre es requerido' : ''" />
          </div>
          <div class="w-full md:w-1/3 mb-3 px-2">
            <wz-select label="Tipo" required :items="typeOptions" v-model="form.type"
              defaultOption="Seleccione tipo" :disabled="editing"
              :error="$v.form.type.$error && !$v.form.type.required ? 'El tipo es requerido' : ''" />
          </div>
          <div class="w-full md:w-1/3 mb-3 px-2">
            <wz-select label="Naturaleza" required :items="natureOptions" v-model="form.nature"
              defaultOption="Seleccione naturaleza"
              :error="$v.form.nature.$error && !$v.form.nature.required ? 'La naturaleza es requerida' : ''" />
          </div>
          <div class="w-full md:w-1/3 mb-3 px-2">
            <div class="wz-form-group">
              <label class="wz-form-label">Afecta IR 5ta categoría</label>
              <div class="mt-2">
                <wz-checkbox v-model="form.affectsFifthCategory" switch size="lg">
                  {{ form.affectsFifthCategory ? 'Sí' : 'No' }}
                </wz-checkbox>
              </div>
            </div>
          </div>
          <div class="w-full mb-3 px-2">
            <wz-textarea label="Descripción" v-model="form.description" placeholder="Descripción opcional del concepto" :rows="3" />
          </div>
        </div>

        <div class="flex justify-end gap-2 mt-2">
          <wz-button type="button" variant="light" @click="$router.push({ name: 'payroll-concept-list' })">{{ editing ? "Volver" : "Cancelar" }}</wz-button>
          <wz-button type="submit" variant="primary" class="ml-2">Guardar</wz-button>
        </div>
      </wz-card>
    </form>
  </div>
</template>

<script>
import { Alert } from "@wizepe/wizeui"
import { required } from 'vuelidate/lib/validators'
import { PayrollConceptService } from '@/core/services'
import { Constants as LocalConstants } from '@/core/utils'

export default {
  data() {
    return {
      editing: false,
      typeOptions:   Object.values(LocalConstants.PayrollConceptType).map(t => ({ key: t.key, label: t.label })),
      natureOptions: Object.values(LocalConstants.PayrollConceptNature).map(n => ({ key: n.key, label: n.label })),
      form: { code: null, name: null, type: null, nature: null, affectsFifthCategory: false, description: null },
    }
  },
  validations: { form: { name: { required }, type: { required }, nature: { required } } },
  watch: { '$route.params.id'() { if (this.$route.params.id) this.load(this.$route.params.id) } },
  methods: {
    async save() {
      this.$v.$touch()
      if (this.$v.$error) return
      try {
        this.$store.dispatch('app/loading', true)
        const data = { code: this.form.code, name: this.form.name, type: this.form.type, nature: this.form.nature, affectsFifthCategory: this.form.affectsFifthCategory || false, description: this.form.description }
        let response
        if (!this.editing) response = await PayrollConceptService.save(data)
        else response = await PayrollConceptService.update(this.$route.params.id, data)
        Alert.success('Se almacenó la información correctamente')
        if (!this.editing) { this.$router.push({ name: 'payroll-concept-edit', params: { id: response.payload.id } }); this.editing = true }
      } catch (ex) { console.error(ex); Alert.error(ex.errors ? ex.errors.message : 'Error al guardar') }
      finally { this.$store.dispatch('app/loading', false) }
    },
    async load(id) {
      try {
        this.$store.dispatch('app/loading', true)
        const payload = (await PayrollConceptService.get(id)).payload
        this.form = { code: payload.code, name: payload.name, type: payload.type, nature: payload.nature, affectsFifthCategory: payload.affectsFifthCategory || false, description: payload.description }
        this.editing = true
      } catch (e) { console.error(e); Alert.error(e.errors ? e.errors.message : 'Error al cargar'); this.$router.push({ name: 'payroll-concept-list' }) }
      finally { this.$store.dispatch('app/loading', false) }
    },
  },
  async created() { if (this.$route.params.id) this.load(this.$route.params.id) },
}
</script>
